function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0.783203 7.98653C1.06085 7.83024 1.19967 7.74341 1.35584 7.65658C6.35344 5.15596 11.3684 2.6727 16.366 0.172077C16.7998 -0.0363086 17.1816 -0.0710565 17.6154 0.154694C22.665 2.67269 27.7147 5.19069 32.7644 7.70868C32.8858 7.77814 33.0073 7.84761 33.2502 7.98653C22.37 7.98653 11.6634 7.98653 0.783203 7.98653Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.9907 33.9999C11.7676 33.9999 6.54437 33.9999 1.32119 33.9999C0.123847 33.9999 -0.309972 33.34 0.227964 32.2807C0.557666 31.6382 0.95678 31.0304 1.40795 30.4574C1.59883 30.2143 1.99795 30.11 2.3103 30.0059C2.55323 29.9364 2.83088 29.9885 3.10852 29.9885C12.4964 29.9885 21.8842 29.9885 31.2547 29.9711C31.9835 29.9711 32.5215 30.1795 32.9032 30.8046C33.2156 31.3256 33.5626 31.8119 33.8229 32.3502C34.2741 33.2879 33.8403 33.9652 32.7818 33.9652C27.5065 33.9999 22.2486 33.9999 16.9907 33.9999Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.9782 10.0527C33.5617 11.5288 32.8155 12.727 31.757 13.7342C31.5314 13.9426 31.0629 13.9947 30.7159 13.9947C22.3171 14.012 13.901 14.0121 5.50229 14.0121C4.68671 14.0121 3.87113 14.0641 3.05555 13.9947C2.69114 13.9599 2.25732 13.7863 1.99703 13.5258C1.05998 12.5707 0.365873 11.4419 0.00146484 10.0701C11.3328 10.0527 22.6295 10.0527 33.9782 10.0527Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.01052 16.0089C4.27081 16.0089 4.49639 16.0089 4.72198 16.0089C6.31843 16.0089 7.89754 16.0089 9.49399 16.0089C9.77163 16.0089 10.0146 15.9915 10.0146 16.4083C9.99722 20.194 10.0146 23.9796 9.99722 27.7653C9.99722 27.8347 9.96251 27.9042 9.94516 28.0084C7.96695 28.0084 6.00608 28.0084 3.99316 28.0084C4.01052 24.0144 4.01052 20.0377 4.01052 16.0089Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M29.9704 28.0094C27.9574 28.0094 25.9966 28.0094 24.001 28.0094C23.9837 27.801 23.9837 27.6274 23.9837 27.4537C23.9837 23.8417 23.9837 20.2297 23.9663 16.6177C23.9663 16.1314 24.1051 15.9751 24.591 15.9925C26.2048 16.0272 27.8186 16.0099 29.4151 16.0099C29.5886 16.0099 29.7621 16.0099 29.9704 16.0099C29.9704 20.0387 29.9704 23.998 29.9704 28.0094Z",
  fill: "currentColor"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M19.939 28.0091C17.9608 28.0091 16.0173 28.0091 14.0391 28.0091C14.0217 27.8007 14.0217 27.6097 14.0217 27.4187C14.0217 23.824 14.0217 20.2293 14.0044 16.6347C14.0044 16.1658 14.1085 15.9922 14.6117 15.9922C16.2429 16.0269 17.8741 16.0096 19.4879 15.9922C19.8002 15.9922 19.9737 16.027 19.9737 16.409C19.9564 20.1773 19.9737 23.9456 19.9564 27.7313C19.9737 27.8181 19.9564 27.8875 19.939 28.0091Z",
  fill: "currentColor"
});

var SvgFinancial = function SvgFinancial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFinancial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Financial.880a43fa.svg";
export { ForwardRef as ReactComponent };